import useTranslation from 'hooks/useTranslation'
import React from 'react'
import './style.scss'

interface OptionProps {
  title: string
  desc: string
  label?: string
  icon?: JSX.Element | string
  selected?: boolean
  secondary?: boolean
  buttonText?: string
  action?: React.MouseEventHandler<HTMLElement>
}

const Option: React.FC<OptionProps> = ({ title, desc, label, icon = 'payments', selected = false, secondary = false, action, buttonText = '' }) => {
  const { t } = useTranslation('basic')

  return (
    <div className={`option${selected ? ' --selected' : ''}${secondary ? ' --secondary' : ''}`}>
      {label && <div className='option__label'>
        <span>{label}</span>
      </div>}

      <div className='center'>
        <div className='option__icon center'>
          {typeof icon === 'string'
            ? <i className={`icon icon--${icon} s24`} />
            : icon}
        </div>

        <div className='option__title'>
          <div className='--secFont'>{title}</div>
          <div>{desc}</div>
        </div>
      </div>

      {action && <div
        className='option__button'
        onClick={action}>{buttonText ? buttonText : t(selected ? 'selected' : 'choose')}</div>}
    </div>
  )
}

export default Option